import { render, staticRenderFns } from "./foldSide.vue?vue&type=template&id=aa3f370e&scoped=true"
import script from "./foldSide.vue?vue&type=script&lang=js"
export * from "./foldSide.vue?vue&type=script&lang=js"
import style0 from "./foldSide.vue?vue&type=style&index=0&id=aa3f370e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3f370e",
  null
  
)

export default component.exports